document.addEventListener('DOMContentLoaded', filterCategories);
document.addEventListener('DOMContentLoaded', hoverCategories);
document.addEventListener('DOMContentLoaded', setupImageSwitcher);
document.addEventListener('DOMContentLoaded', applyDefaultFilter);
document.addEventListener('DOMContentLoaded', setupMobileFilterToggle);

function applyDefaultFilter() {
  const grid = document.querySelector('.lm-product-grid');
  const defaultFilter = grid ? grid.getAttribute('data-default-filter') : 'all';

  if (defaultFilter && defaultFilter !== 'all') {
    const filterButton = document.querySelector(
      `.lm-filter-button[data-filter="${defaultFilter}"]`,
    );
    if (filterButton) {
      filterButton.click();
    }
  }
}

function setupMobileFilterToggle() {
  const toggleButton = document.querySelector('.lm-filter-toggle');
  const filterButtons = document.querySelector('.lm-filter-buttons');
  const filterContainer = document.querySelector('.lm-product-filter');
  const allButton = document.querySelector('.lm-filter-button[data-filter="all"]');

  if (toggleButton && filterButtons) {
    // Toggle filters
    toggleButton.addEventListener('click', function (e) {
      e.stopPropagation();
      this.classList.toggle('active');
      filterButtons.classList.toggle('expanded');
    });

    // Close filters when a filter button is clicked on mobile
    const buttons = filterButtons.querySelectorAll('.lm-filter-button');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (window.innerWidth <= 767) {
          toggleButton.classList.remove('active');
          filterButtons.classList.remove('expanded');
        }
      });
    });

    // Close on click outside and reset to ALL
    document.addEventListener('click', function (e) {
      if (window.innerWidth <= 767 && filterContainer && !filterContainer.contains(e.target)) {
        if (toggleButton.classList.contains('active')) {
          toggleButton.classList.remove('active');
          filterButtons.classList.remove('expanded');
          if (allButton) {
            allButton.click();
          }
        }
      }
    });

    // Close on resize to desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth > 767) {
        toggleButton.classList.remove('active');
        filterButtons.classList.remove('expanded');
      }
    });
  }
}

function filterCategories() {
  var filterButtons = document.querySelectorAll('.lm-product-filter button');
  var products = document.querySelectorAll('.lm-product-link');

  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      // Remove the 'active' class from all buttons
      filterButtons.forEach(function (btn) {
        btn.classList.remove('active');
        btn.style.color = 'rgba(0,0,0,0.5)';
      });
      // Add the 'active' class to the clicked button
      this.classList.add('active');
      this.style.color = 'rgba(0,0,0,0.8)';

      var filterValue = this.getAttribute('data-filter');
      console.log('Filter value: ' + filterValue);

      products.forEach(function (product) {
        var tags = JSON.stringify(
          product.getAttribute('data-tags').toLowerCase(),
        );
        console.log('Tags: ' + tags);

        if (filterValue === 'all' || tags.includes(filterValue)) {
          product.style.display = 'block';
        } else {
          product.style.display = 'none';
        }
      });
    });
  });
}

function hoverCategories() {
  // Get all buttons with the class 'lm-filter-button'
  const buttons = document.querySelectorAll('.lm-filter-button');

  // Function to fetch stock for the given tag
  async function fetchStock(tag) {
    console.log('Hovered tag: ' + tag);
    try {
      const response = await fetch(`/products.json?tag=${tag}`);
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      const data = console.log(await response.json());
      console.log('Fetch data: ' + JSON.stringify(data));
      let totalStock = 0;

      data.products.forEach((product) => {
        product.variants.forEach((variant) => {
          totalStock += variant.inventory_quantity;
        });
      });

      return totalStock;
    } catch (error) {
      console.error('Error fetching stock:', error);
      return null;
    }
  }

  // Function to handle mouseover event
  async function handleMouseOver(event) {
    // Store the original text in a data attribute
    event.target.dataset.originalText = event.target.textContent;

    // Get the tag from the data attribute
    const tag = event.target.getAttribute('data-filter');

    // Fetch the stock for the tag
    const stock = await fetchStock(tag);

    if (stock !== null) {
      // Update the button's text content with the stock quantity
      event.target.textContent += ` (${stock})`;
    }
  }

  // Function to handle mouseout event
  function handleMouseOut(event) {
    // Restore the original text from the data attribute
    event.target.textContent = event.target.dataset.originalText;
  }

  // Add event listeners to each button
  buttons.forEach((button) => {
    button.addEventListener('mouseover', handleMouseOver);
    button.addEventListener('mouseout', handleMouseOut);
  });
}

function switchToPrimaryImage(wrapper) {
  wrapper.querySelector('.lm-product__image').style.display = 'block';
  wrapper.querySelector('.lm-product__image-secondary').style.display = 'none';
}

function switchToSecondaryImage(wrapper) {
  wrapper.querySelector('.lm-product__image').style.display = 'none';
  wrapper.querySelector('.lm-product__image-secondary').style.display = 'block';
}

function setupImageSwitcher() {
  document
    .querySelectorAll('.lm-product__image-wrapper')
    .forEach(function (wrapper) {
      wrapper.addEventListener('mouseenter', function () {
        switchToSecondaryImage(wrapper);
      });

      wrapper.addEventListener('mouseleave', function () {
        switchToPrimaryImage(wrapper);
      });
    });
}
